import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets  = ['panel', 'overlay']
  static stateKey = 'meeting_engine_admin:menu-state'

  connect() {
    const state = localStorage.getItem(this.stateKey)
    if (state !== null) {
      this.panelTarget.toggleAttribute('data-compact', JSON.parse(state))
    }
  }

  open() {
    this.element.toggleAttribute('data-open', true)
    enter(this.panelTarget)
    enter(this.overlayTarget)
  }

  close() {
    this.element.toggleAttribute('data-open', false)
    leave(this.panelTarget)
    leave(this.overlayTarget)
  }

  toggleCompact() {
    const state = !this.panelTarget.hasAttribute('data-compact')
    this.panelTarget.toggleAttribute('data-compact', state)
    localStorage.setItem(this.stateKey, state)
  }

  toggleSubmenu(event) {
    event.currentTarget.closest('[data-type="with-submenu"]').toggleAttribute('data-open')
  }

  search() {
    this.dispatch('search')
  }
}
